import * as metadata from '../metadata.json';

export const getValueBanner = (statusLabel) => {
  switch (statusLabel) {
    case 'empty':
      return 'statusEmpty';
    case 'incomplete':
      return 'statusStarted';
    case 'expiring':
      return 'statusExpiring';
    case 'expired':
      return 'statusExpired';
    case 'completed':
      return 'statusCompleted';

    default:
      return null;
  }
};

export const getFilterLabel = (key) => {
  switch (key) {
    case 'categories':
    case 'category':
      return 'Area tematica';
    case 'subject':
      return 'Materia';
    case 'course_level':
      return 'Livello';
    case 'months':
      return 'Data';
    case 'typology':
    case 'mandatory_courses':
    case 'action':
      return 'Tipologia';
    case 'format':
      return 'Formato';
    case 'duration':
      return 'Durata';
    case 'ffoo':
      return "Forza dell'Ordine";
    case 'user_work_role':
      return 'Ruolo';
    case 'course_status':
    case 'published':
      return 'Visibilità';
    case 'groups':
    case 'group_ids':
      return 'Gruppo di appartenenza';
    case 'publication_date':
      return 'Periodo di pubblicazione';
    case 'regions':
    case 'region':
      return 'Regione';
    case 'provinces':
    case 'province':
      return 'Provincia';
    case 'publication_years':
      return 'Periodo di pubblicazione';
    case 'participation_date':
      return 'Periodo di partecipazione';
    case 'APPROVED':
      return 'Approvato';
    case 'REJECTED':
      return 'Rifiutato';
    case 'TO_BE_APPROVED':
      return 'In attesa di approvazione';
    case 'with_attendance':
    case 'with_attendace':
      return 'Con appello';
    case 'without_attendance':
      return 'Senza appello';
    case 'limited_access':
      return 'Accesso limitato';
    case 'free_access':
      return 'Accesso libero';
    case 'activity_session_virtual_room':
      return 'Virtuale';
    case 'activity_session_in_place_room':
      return 'In presenza';
    case 'course_and_event':
      return 'Corsi ed eventi';
    case 'nazionali_locali':
      return 'Nazionali e locali';
    case 'passed':
      return 'Superato';
    case 'not_passed':
      return 'Non superato';
    case 'not_visible':
      return 'Non abilitato';
    case 'in_progress':
      return 'In corso';
    case 'to_begin':
      return 'Da avviare';
    case 'roles':
      return 'Tipologia profilo';
    case 'table':
      return 'Tipologia azione';
    case 'activity_title':
    case 'activity_titles':
      return 'Titolo attività';

    default:
      return key;
  }
};

export const getFilterOptions = (filters, key) => {
  if (!filters[key]?.length > 0) return [];
  return key === 'categories'
    ? filters[key].map((opt) => ({ label: opt.label, value: opt.id }))
    : filters[key].map((opt) => ({
        label: opt.description || opt.value,
        value: opt.key,
      }));
};

export const getSortingLabel = (id) => {
  switch (id) {
    case 'alphabetical':
    case 'alphabetical_asc':
      return 'Ordine alfabetico (A-Z)';
    case 'alphabetical_desc':
      return 'Ordine alfabetico (Z-A)';

    case 'created':
    case 'created_asc':
    case 'publication':
    case 'publication_asc':
      return '↓ Data di pubblicazione';
    case 'created_desc':
    case 'publication_desc':
      return '↑ Data di pubblicazione';

    case 'completion_date':
    case 'completion_date_asc':
      return '↓ Data di completamento';
    case 'completion_date_desc':
      return '↑ Data di completamento';

    case 'rate':
    case 'rate_asc':
    case 'quiz_result':
    case 'quiz_result_asc':
      return '↓ Punteggio del quiz';
    case 'rate_desc':
    case 'quiz_result_desc':
      return '↑ Punteggio del quiz';

    case 'quiz_status':
    case 'quiz_status_asc':
      return '↓ Stato Quiz';
    case 'quiz_status_desc':
      return '↑ Stato Quiz';

    case 'presence':
    case 'presence_asc':
      return '↓ Presenza';
    case 'presence_desc':
      return '↑ Presenza';

    case 'not_read':
      return 'Non lette';

    case 'first_name':
    case 'first_name_asc':
      return '↓ dalla A alla Z';
    case 'first_name_desc':
      return '↑ dalla Z alla A';

    case 'ffoo':
    case 'ffoo_asc':
      return "↓ Forza dell'Ordine";
    case 'ffoo_desc':
      return "↑ Forza dell'Ordine";

    case 'type':
    case 'type_asc':
      return '↓ Tipologia';
    case 'type_desc':
      return '↑ Tipologia';

    case 'access':
    case 'access_asc':
    case 'last_access':
    case 'last_access_asc':
      return '↓ Ultimo accesso';
    case 'access_desc':
    case 'last_access_desc':
      return '↑ Ultimo accesso';

    case 'last_update':
    case 'last_update_asc':
      return '↓ Ultima modifica';
    case 'last_update_desc':
      return '↑ Ultima modifica';

    case 'completions':
    case 'completions_asc':
      return '↓ Completamenti';
    case 'completions_desc':
      return '↑ Completamenti';

    case 'xxx':
    case 'xxx_asc':
      return '↓ yyy';
    case 'xxx_desc':
      return '↑ yyy';

    default:
      return id;
  }
};

export const getSortingOptions = (sortingIds) => {
  const options = [];
  sortingIds.forEach((id) => {
    options.push({ label: getSortingLabel(id), value: id });
  });
  return options;
};

// fixed options
export const DURATION_OPTIONS = [
  { label: 'Breve (meno di 60 min)', value: 'short' },
  { label: 'Medio (tra 60 e 120 min)', value: 'intermediate' },
  { label: 'Lungo (più di 120 min)', value: 'long' },
];

export const VISIBILITY_OPTIONS = [
  { label: 'Visibile', value: '1' },
  { label: 'Non visibile', value: '0' },
];

export const COURSE_TYPOLOGY_OPTIONS = [
  { label: 'Corso', value: 'course' },
  { label: 'Evento', value: 'event' },
];

export const COURSE_ACTIVITY_TYPES = [
  { label: 'Scorm', value: 'scorm' },
  { label: 'Quiz', value: 'quiz' },
];

export const EVENT_REGISTRATION_OPTS = [
  { label: 'Con appello', value: 'with_attendance' },
  { label: 'Senza appello', value: 'without_attendance' },
];

export const EVENT_ACCESS_OPTS = [
  { label: 'Libero', value: 'free_access' },
  { label: 'Limitato', value: 'limited_access' },
];

export const HOURS_OPTS = [];
for (let h = 0; h < 24; h++) {
  for (let mm = 0; mm < 60; mm += 15) {
    HOURS_OPTS.push({
      label: `${h < 10 ? `0${h}` : h}:${mm < 10 ? `0${mm}` : mm}`,
      value: (60 * h + mm) * 60,
    });
  }
}

export const APPROVAL_STATUS_OPTIONS = [
  { label: 'Approvato', value: 'APPROVED' },
  { label: 'In attesa di approvazione', value: 'TO_BE_APPROVED' },
  { label: 'Richiesta di modifica', value: 'REJECTED' },
];

export const getLabelByRole = (role) => {
  switch (role) {
    case 'consumer':
      return 'Discente';
    case 'tutor':
      return 'Tutor';
    case 'cotutor':
      return 'Cotutor';
    case 'admin':
      return 'Admin';
    case 'supervisor':
      return 'Supervisor';
    case 'expert':
    case 'subject_expert':
      return 'Esperto della materia';

    default:
      return role;
  }
};

export const getLabelByReportType = (type) => {
  switch (type) {
    case 'csv_charts_users':
      return 'Report grafici: Utenti';
    case 'csv_charts_access':
      return 'Report grafici: Accessi';
    case 'csv_charts_tutors':
      return 'Report grafici: Tutor';
    case 'csv_charts_categories':
      return 'Report grafici: Aree tematiche';
    case 'csv_charts_courses':
      return 'Report grafici: Percorsi formativi';
    case 'csv_charts_activities':
      return 'Report grafici: Attività';
    case 'courses':
      return 'Report percorsi formativi';
    case 'users':
      return 'Report utenti';
    case 'tutors':
      return 'Report tutor';
    case 'categories':
      return 'Report aree tematiche';
    case 'activities':
      return 'Report attività';

    default:
      return type;
  }
};

export const getNameLabel = (u = {}) => {
  return `${u?.first_name} ${u?.last_name} <span>${
    u?.matricola ? `&bull; ${u?.matricola}` : ''
  } ${u?.ffoo?.value ? `&bull; ${u?.ffoo?.value}` : ''} ${
    u?.work_role?.value ? `&bull; ${u?.work_role?.value}` : ''
  }</span>`;
};

export const formatSelectOpt = (opt = {}) => {
  const { id, name } = opt || {};
  if (!id || !name) return null;
  return {
    label: name,
    value: id,
  };
};

export const formatFilterOpt = (opt) => {
  if (!opt) return null;
  return { label: opt?.value, value: opt?.key };
};

export const formatRegionOpt = (opt = {}) => {
  return {
    label: opt.name,
    value: opt.id,
    provinces: opt?.provinces,
  };
};

export const formatProvinceOpt = (opt = {}) => {
  return {
    label: `${opt.name} ${opt.code ? `(${opt.code})` : ''}`,
    value: opt.id,
    code: opt?.code || '',
  };
};

export const COURSE_STATS_OPTS = [
  { label: 'Nazionali e locali', value: 'nazionali_locali' },
  { label: 'Corsi ed eventi', value: 'course_and_event' },
];

export const getLabel = (value) => {
  switch (value) {
    case 'course':
      return 'Corso';
    case 'event':
      return 'Evento';

    default:
      return value;
  }
};

export const getLabelByActivityType = (value) => {
  switch (value) {
    case 'activity_scorm':
      return 'Scorm';
    case 'activity_quiz':
      return 'Quiz';
    case 'activity_session_virtual_room':
      return 'Virtuale';
    case 'activity_session_in_place_room':
      return 'In presenza';

    default:
      return value;
  }
};

export const getPageTitleByPath = (path = '/') => {
  let parsedPath = path;
  if (path.endsWith('/')) parsedPath = path.slice(0, -1);
  return metadata[parsedPath]?.title || 'SISFOR+';
};

export const getPageDescriptionByPath = (path = '/') => {
  let parsedPath = path;
  if (path.endsWith('/')) parsedPath = path.slice(0, -1);
  return metadata[parsedPath]?.description || '';
};
